import { createAsyncAction } from 'typesafe-actions';
import { Language } from '@rootCommon/types/glossary';

export const fetchLanguages = createAsyncAction(
  'FETCH_LANGUAGES_REQUEST',
  'FETCH_LANGUAGES_SUCCESS',
  'FETCH_LANGUAGES_FAILURE',
)<undefined, Language[], Error>();

export default fetchLanguages;
